import { IonCol, IonRow } from "@ionic/react";

interface Props {}

const LogoQualiopi: React.FC<Props> = ({}) => {
  return (
    <IonRow className="ion-justify-content-center" style={{ paddingTop: 10 }}>
      <IonCol size-lg="5" size-sm="10">
        <IonRow className="ion-justify-content-center">
          { /* <img
            style={{
              maxHeight: 100,
            }}
            src={
              "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/divers/thumbnail_Capture+d%E2%80%99%C3%A9cran+2022-10-17+%C3%A0+17.07.44(1).png"
            }
            alt="qualiopi logo"
          /> */}
        </IonRow>
      </IonCol>
    </IonRow>
  );
};

export default LogoQualiopi;
